export default {
  label: {
    "&.MuiInputLabel-root": {
      position: "static",
      display: "inline-flex",
      gap: "1ex",
      mb: "calc(0.5 * var(--rhythm))",
      transform: "none",
    },
  },
  input: {
    "&.MuiInputBase-root": {
      boxShadow: "0 0 var(--width-10) 0 var(--color-grey-light)",
      ".MuiIconButton-root": {
        p: 0,
      },
      ".MuiInputBase-input": {
        paddingY: 0,
        textAlign: "center",
      },
      "&.MuiFilledInput-root": {
        boxShadow: "none",
      },
    },
  },
  error: {},
};
